import { render, staticRenderFns } from "./vue_universal_table.vue?vue&type=template&id=5a52a266&scoped=true&"
import script from "./vue_universal_table.vue?vue&type=script&lang=js&"
export * from "./vue_universal_table.vue?vue&type=script&lang=js&"
import style0 from "./vue_universal_table.vue?vue&type=style&index=0&id=5a52a266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a52a266",
  null
  
)

export default component.exports